module.exports = __webpack_public_path__ + "img/kedo.2cc01f40.png";